module.exports = "<div class=\"video\">\r\n    <h5 data-bind=\"group-title\"></h5>\r\n    <h4 data-bind=\"title\"></h4>\r\n    <p data-bind=\"description\"></p>\r\n</div>";


/*****************
 ** WEBPACK FOOTER
 ** ./client/video/videoView.html
 ** module id = 19
 ** module chunks = 0
 **/